import styled from "styled-components";

const ProductCover = styled.img`
  width: 100%;
  height: 280px;
  object-fit: contain;
`;

export default ProductCover;
